import src from "IMAGE";
export default { src, width: 46, height: 37, blurWidth: 0, blurHeight: 0};
